import React, { useState, useEffect } from 'react';

const CONSENT_KEY = 'gdpr:consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (!stored) {
        setVisible(true);
      }
    } catch {
      // localStorage blocked (e.g. private mode on some browsers) — show banner
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ ts: Date.now(), v: 1 }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.banner}>
        <p style={styles.text}>
          This website uses local storage to remember your language preference and cache page content.
          No tracking cookies or advertising data are collected.{' '}
          <a href="/cookie-policy" style={styles.link}>Cookie Policy</a>
          {' · '}
          <a href="/privacy-policy" style={styles.link}>Privacy Policy</a>
        </p>
        <button onClick={handleAccept} style={styles.button}>
          OK, got it
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    padding: '0 16px 16px',
    pointerEvents: 'none',
  },
  banner: {
    background: '#1a1b1f',
    color: '#fff',
    borderRadius: '8px',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    maxWidth: '900px',
    width: '100%',
    boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
    pointerEvents: 'auto',
  },
  text: {
    margin: 0,
    fontSize: '14px',
    lineHeight: '1.5',
    flex: 1,
  },
  link: {
    color: '#90caf9',
    textDecoration: 'underline',
  },
  button: {
    background: '#fff',
    color: '#1a1b1f',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: 'Montserrat, sans-serif',
  },
};

export default CookieBanner;
